<template lang='pug'>
  div#app
    v-app
      v-main
        router-view
      v-snackbar(v-model="appUpdateExists" :timeout="-1" color="accent" rounded="pill") {{appResource.appUpdateAvailable}}
        template(v-slot:action="{ attrs }")
          v-btn(text v-bind="attrs" @click="reloadUpdateApp" color='primary') {{appResource.update}}
      v-snackbar(v-if='isNpe'
                 v-model="noNpeAccess"
                 :timeout="-1"
                 color="red"
                 centered
                 min-width='33%'
                 min-height='66%'
                 style="white-space: pre;") {{appResource.noNpeAccess}}
</template>

<script>
import UpdateAppMixin from '@/mixins/UpdateAppMixin'
import appResource from '@/resources/app'

const isNpe = process.env.VUE_APP_ENVIRONMENT !== 'production'

export default {
  name: 'app',
  mixins: [UpdateAppMixin],
  data: () => ({
    appResource,
    isNpe,
    noNpeAccess: true
  }),
  mounted () {
    if (isNpe) {
      const intervalId = setInterval(() => {
        const access = this.$store.getters.accountAccess
        const hasAccess = access && access.npe
        this.noNpeAccess = !hasAccess
        if (hasAccess) {
          clearInterval(intervalId)
        }
      }, 1000)
    }
  }
}
</script>

<style lang='scss'>
body {
  background: $dark-accent-background;
}

// url is relative to this file and won't work if placed in .scss file
.pattern-background-purple {
  background: linear-gradient(180deg, $dark-accent-background 0%, $dark-accent-background 50%, $slightly-dark-accent-background 100%);
  color: white;
}

</style>
